import React from "react";
import style from "./AvailabilityAlerts.module.css";
import { Alert } from "react-bootstrap";

export default function AvailabilityAlerts(props) {
  const alerts = [];

  if (!props.isEnabled) {
    alerts.push(`The product ${props.product.sku} itself is disabled.`);
  }

  if (props.product.type_id === "bundle") {
    if (!props.isMainUnitEnabled) {
      alerts.push(`The main unit ${props.mainUnit.sku} is disabled.`);
    }

    if (!props.doesMainUnitHavePrice) {
      alerts.push(
        `The main unit ${props.mainUnit.sku} is not associated with the current price list.`
      );
    }

    if (!props.areDefaultSelectionsEnabled) {
      const skus = props.defaultSelectedProducts
        .filter(product => product.status !== "1")
        .map(product => product.sku)
        .join(", ");
      alerts.push(`The default selected options(s) ${skus} are disabled.`);
    }

    if (!props.doDefaultSelectionsHavePrices) {
      const skus = props.defaultSelectedProducts
        .filter(product => product.price === null)
        .map(product => product.sku)
        .join(", ");
      alerts.push(
        `The default selected options(s) ${skus} are not associated with the current price list.`
      );
    }
  }

  return alerts.length > 0 ? (
    <Alert className={style.root} variant="danger">
      <p>
        The product is not available due to the following reasons. Please
        contact the Product Marketing Team.
      </p>
      <ul>
        {alerts.map((alert, index) => (
          <li key={index}>{alert}</li>
        ))}
      </ul>
    </Alert>
  ) : null;
}
